window.slate = window.slate || {}
window.theme = window.theme || {}
window.stj = window.stj || {}

window.stj.dropdownResultsTemplate =
  '\
{{if results}} \
{{results}} \
  <a href="{{url}}"> \
  <div class="title-and-price"> \
    <span class="title">{{title}}</span> \
    <span class="price">{{formattedPrice}}</span> \
  </div> \
  {{if meta}} \
    {{if meta.producer}}<span class="producer">{{meta.producer}}</span>{{/if}} \
    {{if meta.region}}<span class="region">{{meta.region}}</span>{{/if}} \
    {{if meta.variety}}<span class="variety">{{meta.variety}}</span>{{/if}} \
  {{/if}} \
  </a> \
{{/results}} \
{{else}} \
<p>No matching results found.</p> \
{{/if}}'

stj.equalizeWineImageHeights = function() {
  new Equalizer(
    document.querySelectorAll('.sj-product-wine__image-wrapper')
  ).align()
}

stj.getSearchResults = function(e) {
  var q, queryParams

  q = $('#q').val()

  if (e.which == 13 && q != '') {
    window.location = '/pages/search-results?q=' + q
    return
  }

  if (q.length < 2) {
    $('#stj-search-results-dropdown')
      .html('')
      .removeClass('-visible')
    return
  }

  queryParams = { q: q }

  $.ajax({
    url: 'https://cms.stjohnrestaurant.com/api/search',
    data: queryParams,
    headers: { 'X-St-John-Api-Token': 'C1TZr4rDWzJwKA7XHxhbSdzFtrtAozbejwrr' }
  }).done(function(response) {
    $('#stj-search-results-dropdown')
      .addClass('-visible')
      .html(Mark.up(stj.dropdownResultsTemplate, response))
    stj.searchResultsTether.position()
  })
}

window.stj.throttle = function(func, wait, options) {
  var _ = {
    now:
      Date.now ||
      function() {
        return new Date().getTime()
      }
  }
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function() {
    previous = options.leading === false ? 0 : _.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function() {
    var now = _.now()
    if (!previous && options.leading === false) previous = now
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden'

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback)

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex')
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash))
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash))
      }.bind(this)
    )
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin'

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container
    }

    options.$container.attr('tabindex', '-1')
    options.$elementToFocus.focus()

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus()
      }
    })
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin'

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex')
    }

    $(document).off(eventName)
  }
}

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled

    if (!cookieEnabled) {
      document.cookie = 'testcookie'
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1
    }
    return cookieEnabled
  }
}

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i]
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1)
        break
      }
    }

    return array
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1
    var length = array == null ? 0 : array.length
    var resIndex = 0
    var result = []

    while (++index < length) {
      var value = array[index]
      if (value) {
        result[resIndex++] = value
      }
    }
    return result
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value
  }
}

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>')
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    )
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe')

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>')
    })

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src
    })
  }
}

slate.Sections = function Sections() {
  this.constructors = {}
  this.instances = []

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
}

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container)
    var id = $container.attr('data-section-id')
    var type = $container.attr('data-section-type')

    constructor = constructor || this.constructors[type]

    if (typeof constructor === 'undefined') {
      return
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    })

    this.instances.push(instance)
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0]
    if (container) {
      this._createInstance(container)
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (!instance) {
      return
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt)
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt)
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt)
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt)
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt)
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    )

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt)
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor)
      }.bind(this)
    )
  }
})

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}'

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    var value = ''
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2)
      thousands = slate.utils.defaultTo(thousands, ',')
      decimal = slate.utils.defaultTo(decimal, '.')

      if (isNaN(number) || number == null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split('.')
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      )
      var centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney
  }
})()

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images]
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i]
      this.loadImage(this.getSizedImageUrl(image, size))
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    )

    if (match) {
      return match[1]
    } else {
      return null
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src
    }

    if (size === 'master') {
      return this.removeProtocol(src)
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    )

    if (match) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return this.removeProtocol(prefix[0] + '_' + size + suffix)
    } else {
      return null
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '')
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  }
})()

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container
    this.product = options.product
    this.singleOptionSelector = options.singleOptionSelector
    this.originalSelectorId = options.originalSelectorId
    this.enableHistoryState = options.enableHistoryState
    this.currentVariant = this._getVariantFromOptions()

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    )
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element)
          var type = $element.attr('type')
          var currentOption = {}

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val()
              currentOption.index = $element.data('index')

              return currentOption
            } else {
              return false
            }
          } else {
            currentOption.value = $element.val()
            currentOption.index = $element.data('index')

            return currentOption
          }
        }
      )

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions)

      return currentOptions
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions()
      var variants = this.product.variants
      var found = false

      variants.forEach(function(variant) {
        var satisfied = true

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index]
          }
        })

        if (satisfied) {
          found = variant
        }
      })

      return found || null
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions()

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      })

      if (!variant) {
        return
      }

      this._updateMasterSelect(variant)
      this._updateImages(variant)
      this._updatePrice(variant)
      this.currentVariant = variant

      if (this.enableHistoryState) {
        this._updateHistoryState(variant)
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {}
      var currentVariantImage = this.currentVariant.featured_image || {}

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      })
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      })
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id
      window.history.replaceState({ path: newurl }, '', newurl)
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id
    }
  })

  return Variants
})()

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  }

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container)
    var sectionId = this.$container.attr('data-section-id')

    this.settings = {}
    this.namespace = '.product'

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return
    }

    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    )
    this.settings.imageSize = slate.Image.imageSize(
      $(selectors.productFeaturedImage, this.$container).attr('src')
    )

    slate.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    )

    this.initVariants()
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      }

      this.variants = new slate.Variants(options)

      this.updateProductDescription({
        variant: this.variants.currentVariant
      })

      this.$container.on(
        'variantChange' + this.namespace,
        this.updateAddToCartState.bind(this)
      )
      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      )
      this.$container.on(
        'variantPriceChange' + this.namespace,
        this.updateProductPrices.bind(this)
      )
      this.$container.on(
        'variantChange' + this.namespace,
        this.updateProductDescription.bind(this)
      )
    },

    updateProductDescription: function(evt) {
      var variant = evt.variant
      if (variant.options.indexOf('Case') >= 0) {
        $('[data-case]').show()
      } else {
        $('[data-case]').hide()
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide')
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true)
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        )
        $(selectors.priceWrapper, this.$container).addClass('hide')
        return
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false)
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        )
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true)
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut)
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant
      var $comparePrice = $(selectors.comparePrice, this.$container)
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      )

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      )

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        )
        $compareEls.removeClass('hide')
      } else {
        $comparePrice.html('')
        $compareEls.addClass('hide')
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      )

      $(selectors.productFeaturedImage, this.$container).attr(
        'src',
        sizedImgUrl
      )
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace)
    }
  })

  return Product
})()

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm')

  if (!$newAddressForm.length) {
    return
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew'
      }
    )
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id')
    var countrySelector = 'AddressCountry_' + formId
    var provinceSelector = 'AddressProvince_' + formId
    var containerSelector = 'AddressProvinceContainer_' + formId

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    })
  })

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide')
  })

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id')
    $('#EditAddress_' + formId).toggleClass('hide')
  })

  $('.address-delete').on('click', function() {
    var $el = $(this)
    var formId = $el.data('form-id')
    var confirmMessage = $el.data('confirm-message')
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      })
    }
  })
})()

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  }

  if (!$(config.recoverPasswordForm).length) {
    return
  }

  checkUrlHash()
  resetPasswordSuccess()

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm)
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm)

  function onShowHidePasswordForm(evt) {
    evt.preventDefault()
    toggleRecoverPasswordForm()
  }

  function checkUrlHash() {
    var hash = window.location.hash

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm()
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide')
    $('#CustomerLoginForm').toggleClass('hide')
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success')

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return
    }

    // show success message
    $('#ResetSuccess').removeClass('hide')
  }
})()

var throttle = function(type, name, obj) {
  obj = obj || window
  var running = false
  var func = function() {
    if (running) {
      return
    }
    running = true
    requestAnimationFrame(function() {
      obj.dispatchEvent(new CustomEvent(name))
      running = false
    })
  }
  obj.addEventListener(type, func)
}

throttle('resize', 'optimizedResize')

// stj.wineItem = `{{groups}}
//   {{if products}}
//   <h2 class="sj-h3 -page-header">Featured {{name}}</h2>
//   <div class="sj-collection-wine">
//   {{products}}
//   <a class="sj-product-wine" href="/collections/wines/products/{{handle}}">
//     <svg class="sj-product-wine__image -fallback" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318.3 76.9"><path d="M236.4 21.1c4.8 3 10.2 2.3 15.4 2.8 6.8.7 13.7.9 20.6 1.3 2.5.1 4.9.3 7.4.3 7.2 0 14.5.2 21.7-.1 2.7-.1 5.4-1.3 8.3-.9 1.9.3 3.8.4 5.5 1 .9.4 2.1 1.6 2.2 2.5.4 5 .5 10 .7 14.9 0 1.3 0 2.5-.1 3.8-.3 3.3-1.8 4.7-5 5-.5 0-1 .3-1.5.3-1.5.2-3.2.7-4.6.3-6.2-1.8-12.6-.7-18.9-.9-4.9-.1-9.8 0-14.7.2-5.8.2-11.6.7-17.3 1.1-3.8.2-7.5.5-11.3.8-5.9.5-11 2.6-15 7.2-8.2 9.3-18.5 14.5-30.8 15.5-7.2.5-14.5.6-21.7.6-9 .1-17.9 0-26.9 0-18.9 0-37.8 0-56.8-.1-16.5-.1-32.9-.2-49.4-.4-8.9-.1-17.8-.5-26.7-.8-2.6-.1-5.1-.2-7.7-.3-2.1-.1-3.6-1.2-4.8-2.9-3.5-5.2-4.5-11-4.7-17-.6-14.2-.8-28.4 1-42.5.2-1.4.4-2.8.7-4.2 1-3.8 3.5-6.3 7.4-6.8 3.6-.5 7.2-.7 10.8-.8 7-.2 14-.4 21-.5C51.1.3 61.1.1 71 0c40.3-.1 80.7 0 121-.1 7.5 0 14.7 1.5 21.4 4.6 3.8 1.7 7.4 4.1 11.1 6.2.2.1.3.4.2.8-.8-.5-1.6-1.1-2.4-1.6-6.2-3.4-12.6-6.2-19.6-7.2-2.8-.4-5.7-.2-8.6-.2-12.7 0-25.3-.1-38 0-4.8 0-9.7.4-14.5.4-2.7 0-5.4-.5-8.1-.5-15.6 0-31.3.1-46.9.2h-3.8c-12 0-23.9 0-35.9.2-10.6.2-21.4.8-32.1 1.1-2.4.1-4.6 0-6.5 2C6 8.4 3.9 11 3.8 14.5 3.3 25.8 3.1 37 2.7 48.3c-.2 7.1.3 14.1 2.5 21 1.3 4.1.3 3.6 5 3.7 10.1.3 20.2.5 30.3.7 2.8.1 5.5.2 8.3.2l30.7.3c15.2.1 30.5.3 45.7.3 16.3 0 32.6-.2 48.8-.2 6.6 0 13.3.4 19.9.1 12.5-.6 23.3-5.5 32.2-14.3 1.8-1.8 3.6-3.6 5.6-5.1 4.1-3.2 9-3.8 14-4.2 17.2-1.1 34.3-2.2 51.5-2 1.6 0 3.2.9 4.8 1 2.4.1 4.9-.1 7.3-.2.6 0 1.2-.4 1.8-.5 2.6-.4 4-1.5 4.3-4.2.4-4.3.8-8.6.7-12.9 0-1.6-1.3-3.2-2.1-4.8-.1-.3-.7-.6-1-.6-2.3.1-4.7.3-7 .5-2 .2-4 .8-5.9.7-8.2 0-16.5 0-24.7-.4-10.5-.6-21-1.4-31.5-2.4-2.8 0-5.4-1.5-7.5-3.9z"></path></svg>
//     <h2 class="sj-h3 sj-product-wine__title">{{title}}</h2>
//     <div class="sj-product-wine-meta">
//       <span>{{region}}</span>
//       <span>{{vintage}}</span>
//       <span>From {{fromPrice|toMoney}}</span>
//     </div>
//   </a>
//   {{/products}}
//   </div>
//   {{/if}}
// {{/groups}}`;

stj.wineItem =
  '{{groups}}\n  {{if products}}\n  <h2 class="sj-h3 -page-header">Featured {{name}}</h2>\n  <div class="sj-collection-wine">\n  {{products}}\n  <a class="sj-product-wine" href="/collections/wines/products/{{handle}}">\n    <svg class="sj-product-wine__image -fallback" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318.3 76.9"><path d="M236.4 21.1c4.8 3 10.2 2.3 15.4 2.8 6.8.7 13.7.9 20.6 1.3 2.5.1 4.9.3 7.4.3 7.2 0 14.5.2 21.7-.1 2.7-.1 5.4-1.3 8.3-.9 1.9.3 3.8.4 5.5 1 .9.4 2.1 1.6 2.2 2.5.4 5 .5 10 .7 14.9 0 1.3 0 2.5-.1 3.8-.3 3.3-1.8 4.7-5 5-.5 0-1 .3-1.5.3-1.5.2-3.2.7-4.6.3-6.2-1.8-12.6-.7-18.9-.9-4.9-.1-9.8 0-14.7.2-5.8.2-11.6.7-17.3 1.1-3.8.2-7.5.5-11.3.8-5.9.5-11 2.6-15 7.2-8.2 9.3-18.5 14.5-30.8 15.5-7.2.5-14.5.6-21.7.6-9 .1-17.9 0-26.9 0-18.9 0-37.8 0-56.8-.1-16.5-.1-32.9-.2-49.4-.4-8.9-.1-17.8-.5-26.7-.8-2.6-.1-5.1-.2-7.7-.3-2.1-.1-3.6-1.2-4.8-2.9-3.5-5.2-4.5-11-4.7-17-.6-14.2-.8-28.4 1-42.5.2-1.4.4-2.8.7-4.2 1-3.8 3.5-6.3 7.4-6.8 3.6-.5 7.2-.7 10.8-.8 7-.2 14-.4 21-.5C51.1.3 61.1.1 71 0c40.3-.1 80.7 0 121-.1 7.5 0 14.7 1.5 21.4 4.6 3.8 1.7 7.4 4.1 11.1 6.2.2.1.3.4.2.8-.8-.5-1.6-1.1-2.4-1.6-6.2-3.4-12.6-6.2-19.6-7.2-2.8-.4-5.7-.2-8.6-.2-12.7 0-25.3-.1-38 0-4.8 0-9.7.4-14.5.4-2.7 0-5.4-.5-8.1-.5-15.6 0-31.3.1-46.9.2h-3.8c-12 0-23.9 0-35.9.2-10.6.2-21.4.8-32.1 1.1-2.4.1-4.6 0-6.5 2C6 8.4 3.9 11 3.8 14.5 3.3 25.8 3.1 37 2.7 48.3c-.2 7.1.3 14.1 2.5 21 1.3 4.1.3 3.6 5 3.7 10.1.3 20.2.5 30.3.7 2.8.1 5.5.2 8.3.2l30.7.3c15.2.1 30.5.3 45.7.3 16.3 0 32.6-.2 48.8-.2 6.6 0 13.3.4 19.9.1 12.5-.6 23.3-5.5 32.2-14.3 1.8-1.8 3.6-3.6 5.6-5.1 4.1-3.2 9-3.8 14-4.2 17.2-1.1 34.3-2.2 51.5-2 1.6 0 3.2.9 4.8 1 2.4.1 4.9-.1 7.3-.2.6 0 1.2-.4 1.8-.5 2.6-.4 4-1.5 4.3-4.2.4-4.3.8-8.6.7-12.9 0-1.6-1.3-3.2-2.1-4.8-.1-.3-.7-.6-1-.6-2.3.1-4.7.3-7 .5-2 .2-4 .8-5.9.7-8.2 0-16.5 0-24.7-.4-10.5-.6-21-1.4-31.5-2.4-2.8 0-5.4-1.5-7.5-3.9z"></path></svg>\n    <h2 class="sj-h3 sj-product-wine__title">{{title}}</h2>\n    <div class="sj-product-wine-meta">\n      <span>{{producer}}</span>\n      <span>{{region}}</span>\n      <span>From {{fromPrice|toMoney}}</span>\n    </div>\n  </a>\n  {{/products}}\n  </div>\n  {{/if}}\n{{/groups}}'

// stj.wineListItem = `{{groups}}
//   {{if products}}
//   <h2 class="sj-h3 -page-header">{{name}}</h2>
//   {{products}}
//     <a class="sj-product-wine-list" href="/collections/wine-list/products/{{handle}}">
//     <h2 class="sj-product-wine-list__title">{{title}}</h2>
//     <span class="sj-product-wine-list-meta">{{vintage}}</span>
//     <span class="sj-product-wine-list-meta sj-util-italics">({{variety}})</span>
//     {{if region}}<span class="sj-product-wine-list-meta -region">{{region}}</span>{{/if}}
//     <span class="sj-product-wine-list-meta -price">{{fromPrice|toMoney}}</span>
//   </a>{{/products}}
//   {{/if}}
// {{/groups}}`;

stj.wineListItem =
  '{{groups}}\n  {{if products}}\n  <h2 class="sj-h3 -page-header">{{name}}</h2>\n  {{products}}\n    <a class="sj-product-wine-list" href="/collections/wine-list/products/{{handle}}">\n    <h2 class="sj-product-wine-list__title">{{title}}</h2>\n    <span class="sj-product-wine-list-meta">{{vintage}}</span>\n    {{if producer}}<span class="sj-product-wine-list-meta sj-util-italics">{{producer}}</span>\n{{/if}}    {{if region}}<span class="sj-product-wine-list-meta -region">{{region}}</span>{{/if}}\n    <span class="sj-product-wine-list-meta -price">{{fromPrice|toMoney}}</span>\n  </a>{{/products}}\n  {{/if}}\n{{/groups}}'

stj.fixHeaderPosititioning = function() {
  // $('.sj-header').css('margin-top', $('.sj-masthead').outerHeight());
}

Mark.pipes.toMoney = function(str) {
  return Shopify.formatMoney(str, theme.moneyFormat)
}

stj.getProducts = function(callback, params) {
  queryParams = {}
  if (currentTags) {
    for (var i = 0; i < currentTags.length; ++i) {
      var parts, tag
      tag = currentTags[i]
      parts = tag.split(/-(.+)/)
      queryParams[parts[0]] = parts[1].replace(' Wine', '')
    }
  }
  console.log('queryParams', queryParams)
  $.ajax({
    url: 'https://cms.stjohnrestaurant.com/api/products',
    data: queryParams,
    headers: { 'X-St-John-Api-Token': 'C1TZr4rDWzJwKA7XHxhbSdzFtrtAozbejwrr' }
  }).done(callback)
}

$(function() {
  FastClick.attach(document.body)

  $(document).on('keyup', '#q', stj.throttle(stj.getSearchResults, 200))
  $(document).on('focusout', '#q', function() {
    $('#stj-search-results-dropdown').removeClass('-visible')
  })

  if ($('#q').length) {
    stj.searchResultsTether = new Tether({
      element: $('#stj-search-results-dropdown')[0],
      target: $('#q')[0],
      attachment: 'top right',
      targetAttachment: 'bottom right'
    })
  }

  $('.reservations-date').each(function() {
    var $this = $(this)
    var val = $this.data('val')
    rome(this, {
      time: false,
      initialValue: val,
      min: val
    })
  })

  // var reservationsHtml = $('#reservations-html').html();
  // console.log(reservationsHtml);
  // $('.sj-reservations__content').html(reservationsHtml);

  //   if ($('[data-amazon]').length) {
  var $aEls
  $aEls = $('.shopify-description')
    .find('a')
    .filter(function() {
      return /amazon/.test($(this).attr('href'))
    })
  $aEls.hide()
  //     if ($aEls.length) {
  //       $('[data-amazon]').attr('href', $aEls.eq(0).attr('href'));
  //       $aEls.remove();
  //     } else {
  //       $('[data-amazon]').hide()
  //     }
  //   }

  if ($('.sj-product').length && $('.sj-related-wine').length) {
    var handle
    handle = $('.sj-product').data('handle')
    $('.sj-related-wine')
      .children('[data-handle="' + handle + '"]')
      .remove()
    $('.sj-related-wine')
      .children()
      .pick(3)
  }

  if ($('.sj-product').length && $('.sj-related-products').length) {
    var handle
    handle = $('.sj-product').data('handle')
    $('.sj-related-products')
      .children('[data-handle="' + handle + '"]')
      .remove()
    $('.sj-related-products')
      .children()
      .pick(3)
  }

  if ($('.sj-collection-wine.-carousel').length) {
    $('.sj-collection-wine.-carousel').each(function() {
      if ($(this).children().length == 1) {
        return
      }
      $(this).flickity({
        wrapAround: true,
        watchCSS: true,
        pageDots: false,
        arrowShape:
          'M.844 10.69l-.005.005 7.944 8.74.004-.004c.01.01.01.024.02.033.31.31.814.31 1.124 0 .3-.3.305-.78.022-1.09l.005-.006-6.738-7.41h22.04c.44 0 .796-.356.796-.795 0-.44-.357-.793-.796-.793H3.224L9.96 1.952l-.004-.003c.283-.313.28-.79-.022-1.092-.31-.31-.813-.31-1.124 0-.01.01-.013.022-.02.032L8.784.887.84 9.627l.004.003c-.274.302-.274.758 0 1.06'
      })
    })
  }

  // if ($('.sj-restaurant__hero-images').length) {
  //   $('.sj-restaurant__hero-images').removeClass('owl-carousel');
  //   $('.sj-restaurant__hero-images').flickity({
  //     wrapAround: true,
  //     pageDots: false,
  //     arrowShape: 'M.844 10.69l-.005.005 7.944 8.74.004-.004c.01.01.01.024.02.033.31.31.814.31 1.124 0 .3-.3.305-.78.022-1.09l.005-.006-6.738-7.41h22.04c.44 0 .796-.356.796-.795 0-.44-.357-.793-.796-.793H3.224L9.96 1.952l-.004-.003c.283-.313.28-.79-.022-1.092-.31-.31-.813-.31-1.124 0-.01.01-.013.022-.02.032L8.784.887.84 9.627l.004.003c-.274.302-.274.758 0 1.06'
  //   });
  // };

  $('.sj-filter-options').each(function() {
    SimpleScrollbar.initEl(this)
  })

  if ($('#page-contact').length) {
    $('<script>', {
      src:
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCblRgzkKQQnPPAkXPWC_nk_JhQ2dGw-Ek&callback=initMap'
    }).appendTo('head')
  }

  if ($('.sj-product-meta').length) {
    enquire.register('(min-width: 768px)', {
      match: function() {
        $('.sj-product-meta')
          .detach()
          .insertAfter('.sj-product-image')
      },
      unmatch: function() {
        $('.sj-product-meta')
          .detach()
          .insertBefore('.shopify-description')
      },
      setup: function() {
        if (matchMedia('(min-width: 768px)').matches) {
          $('.sj-product-meta')
            .detach()
            .insertAfter('.sj-product-image')
        } else {
          $('.sj-product-meta')
            .detach()
            .insertBefore('.shopify-description')
        }
      }
    })
  }

  if ($('#page-our-story').length) {
    // window.sr = ScrollReveal({
    //   viewFactor: 1,
    //   distance: '0px',
    //   scale: 1,
    //   reset: true
    // });
    // sr.reveal('.sr');

    $('.sj-our-story-footer').waypoint({
      offset: '100%',
      handler: function(direction) {
        if (direction == 'up') {
          $('.sj-our-story-footer').removeClass('-in-view')
        } else {
          $('.sj-our-story-footer').addClass('-in-view')
        }
      }
    })

    $('.sr').waypoint({
      offset: '50%',
      handler: function(direction) {
        if (direction == 'up') {
          $(this.element).removeClass('-visible')
        } else {
          $(this.element).addClass('-visible')
        }
      }
    })
  }

  stj.fixHeaderPosititioning()

  CartJS.init(window.cartJS.cart, {
    moneyFormat: window.cartJS.moneyFormat,
    moneyWithCurrencyFormat: window.cartJS.moneyWithCurrencyFormat
  })

  var sections = new slate.Sections()
  sections.register('product', theme.Product)

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash))

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
  })

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable()
  slate.rte.iframeReset()

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    )
  }

  // if ($('.sj-collection-wine.-home').length) {
  //   console.log('.sj-collection-wine.-home');
  //   stj.getProducts(function(response){
  //     $('.sj-collection-wine.-home').replaceWith(Mark.up(stj.wineItem, response));
  //   }, { per_type: 3 });
  // }

  if ($('.sj-collection-wine-list').length) {
    stj.getProducts(function(response) {
      $('.sj-collection-wine-list').html(Mark.up(stj.wineListItem, response))
      $('.sj-product-wine-list__title').each(function() {
        $(this).text($(this).text())
      })
      $('.pagination').remove()
      $(
        '.sj-product-wine__title, .sj-product-wine-list__title, .sj-product__title'
      ).each(function() {
        $(this).text(
          $(this)
            .text()
            .replace(/\b\d{4}\b/, '')
        )
      })
      ElementQueries.init()
    })
  }
})

$(window).on('load', stj.fixHeaderPosititioning)

$(window).on('optimizedResize', function() {
  stj.fixHeaderPosititioning()
  stj.equalizeWineImageHeights()
})

$(document).on('mouseover', '.sj-navigation__footer', function() {
  $('.sj-navigation__image').hide()
})

$(document).on('mouseover', '.sj-navigation__image', function() {
  $('.sj-navigation__image').hide()
})

$(document).on('mouseover', '.sj-navigation__item', function() {
  var $image, $item, url, position
  $item = $(this)
  $image = $('.sj-navigation__image')
  $image.show()

  // url = $item.data('image');

  var href = $item.attr('href')
  var imgEl = $('img[data-href="' + href + '"]')[0]
  if (imgEl) {
    if (imgEl.currentSrc) {
      url = imgEl.currentSrc
    } else {
      url = imgEl.src
    }

    position = $item.data('image-position')
    $image.css('background-image', 'url(' + url + ')')
    $image.removeClass('-left -right').addClass('-' + position)
  }
})

$(document).on('click', 'a', function(e) {
  if (this.hostname != window.location.hostname) {
    e.preventDefault()
    window.open(this.getAttribute('href'), '_blank')
  }
})

var launchPig

launchPig = function(options) {
  var $pig,
    $target,
    fromX,
    fromY,
    pigEl,
    pigHalfHeight,
    pigHalfWidth,
    targetHalfHeight,
    targetHalfWidth,
    tl,
    toOffset,
    toX,
    toY
  if (options == null) {
    options = {}
  }
  $pig = $('<div class="sj-pig">').appendTo('body')
  $target = $(options.target)
  pigEl = $pig[0]
  pigHalfWidth = $pig.outerWidth() / 2
  pigHalfHeight = $pig.outerHeight() / 2
  targetHalfWidth = $target.outerWidth() / 2
  targetHalfHeight = $target.outerHeight() / 2
  toOffset = $target.position()
  fromX = options.event.clientX - pigHalfWidth
  fromY = options.event.clientY - pigHalfHeight
  // toX = (toOffset.left + targetHalfWidth) - pigHalfWidth - fromX;
  // toY = (toOffset.top + targetHalfHeight) - pigHalfHeight - fromY;
  toX = toOffset.left + targetHalfWidth - pigHalfWidth // - fromX;
  toY = toOffset.top + targetHalfHeight - pigHalfHeight // - fromY;
  $pig.show()
  tl = new TimelineLite()
  tl.timeScale(0.8)
  tl.set(pigEl, { scale: 0, rotation: -90, top: fromY, left: fromX }, 0)
  tl.to(pigEl, 0.3, { scale: 1, ease: Power1.easeOut }, 0)
  tl.to(pigEl, 0.7, { scale: 0, ease: Power1.easeIn }, 0.3)
  tl.to(pigEl, 1, { left: toX }, 0)
  // tl.to(pigEl, 1, { y: toY, ease: Back.easeOut.config(1.7) }, 0);
  tl.to(pigEl, 1, { top: toY, ease: Power4.easeOut }, 0)
  tl.to(pigEl, 1, { ease: Power1.easeOut, rotation: -5 }, 0)
  tl.call(function() {
    $pig.remove()
  })
}

$(document).on('click', '.shopify-product-form :submit', function(e) {
  console.log('launch pig')
  var validity = []
  var errorMessages = []
  var $inputs = $(this)
    .parents('form')
    .find(':input')
  console.log('$inputs', $inputs)
  $inputs.each(function() {
    var inputValid = this.checkValidity()
    if (!inputValid) {
      errorMessages.push($(this).attr('placeholder'))
    }
    validity.push(inputValid)
  })
  if (validity.indexOf(false) === -1) {
    launchPig({ event: e, target: '#basket' })
  } else {
    e.preventDefault()
    e.stopImmediatePropagation()
    if (errorMessages.length > 0) {
      alert(
        'Please complete the following fields:\n- ' + errorMessages.join('\n- ')
      )
    }
  }
})

$(document).on('submit', '.shopify-product-form', function(e) {
  e.preventDefault()
  var $form, $submitButton, variantId
  $form = $(this)
  console.log('submit product form')
  //   console.log('checkValidity', this.checkValidity());
  $submitButton = $form.find(':submit')
  $submitButtonText = $form.find('[data-add-to-cart-text]')
  variantId = $form.find('[data-product-select]').val()

  $submitButton.prop('disabled', true)
  $submitButtonText.text('Adding…')
  // CartJS.addItem(variantId, 1, {}, {
  //   success: function(data) {
  //     $submitButton.prop('disabled', false);
  //     $submitButtonText.text('Added');
  //     setTimeout(function() {
  //       $submitButtonText.text('Add to Basket');
  //     }, 2000);
  //   },
  //   error: function() {
  //     $submitButton.prop('disabled', false).val('Add to Basket');
  //   }
  // });
})

var renderShippingOptions = function() {
  if ($('.sj-cart-shipping').length === 0) {
    return
  }

  var cartItems = cart.items
  var merchItemsCount = cartItems.filter(function(i) {
    return i.vendor !== 'Vintner' && i.vendor !== 'Vision'
  }).length

  if (merchItemsCount >= 1) {
    $('.sj-cart-shipping').hide()
    $('[name="shipping"][value="deliver"]').prop('checked', true)
  } else {
    $('.sj-cart-shipping').show()
  }
}

$(document).on('cart.ready', function(event, cart) {
  window.cart = cart
  renderShippingOptions()
})

$(document).on('cart.requestComplete', function(event, cart) {
  window.cart = cart
  $('[data-cart-item-count]').text(cart.item_count)

  $form = $('.shopify-product-form')
  $submitButton = $form.find(':submit')
  $submitButtonText = $form.find('[data-add-to-cart-text]')

  var currentProductId = $('.sj-product').data('section-id')
  var maxValue = $('[data-max-value]').data('max-value')

  if (maxValue) {
    var quantity = cart.items.find(item => item.product_id === currentProductId).quantity
    if (quantity >= maxValue) $submitButton.prop('disabled', true)
    $submitButtonText.text('Maximum added')
  } else {
    $submitButton.prop('disabled', false)
    $submitButtonText.text('Added')
    setTimeout(function() {
      $submitButtonText.text('Add to Basket')
    }, 2000)
  }

  renderShippingOptions()
})

$(function() {
  var currentProductId = $('.sj-product').data('section-id')
  var maxValue = $('[data-max-value]').data('max-value')

  if (!maxValue) return

  $form = $('.shopify-product-form')
  $submitButton = $form.find(':submit')
  $submitButtonText = $form.find('[data-add-to-cart-text]')

  var quantity = CartJS.cart.items.find(item => item.product_id === currentProductId).quantity

  if (quantity < maxValue) {
    $('.shopify-quantity__input').data('max-value', maxValue - quantity)
    return
  }

  $submitButton.prop('disabled', true)
  $submitButtonText.text('Maximum added')
})

$(document).on('cart.requestError', function(event, cart, response) {
  alert(response.responseJSON.description)
})

$(document).on('click', '[data-owl-trigger]', function() {
  var $this, owl
  $this = $(this)
  owl = $this.parents('.owl-carousel').owlCarousel()
  owl.trigger($this.data('owl-trigger') + '.owl.carousel')
})

// var filterHeightEvent = matchMedia('(pointer: fine)').matches ? 'mouseenter' : 'click';
var filterHeightEvent = Modernizr.touchevents ? 'click' : 'mouseenter'

$(document).on(filterHeightEvent, '.sj-filters__item', function() {
  var $this, $options, distanceFromTop, maxHeight
  $this = $(this)
  $options = $this.find('.sj-filter-options')
  distanceFromTop = $this.offset().top - $(window).scrollTop()
  maxHeight = window.innerHeight - distanceFromTop - $this.outerHeight() - 30

  if ($options.find('.ss-content').length) {
    var scrollHeight = $options.find('.ss-content')[0].scrollHeight + 24
  } else if (typeof $options !== 'undefined') {
    var scrollHeight = $options[0].scrollHeight + 24
  }

  if (scrollHeight > maxHeight) {
    $options.css('height', maxHeight)
  } else {
    $options.css('height', scrollHeight)
  }
})

$(document).on('click', '.sj-filters__item.-has-dropdown', function(e) {
  if (
    $(e.target).hasClass('sj-filters__item') ||
    $(e.target).hasClass('sj-filters__item__label')
  ) {
    $(this).toggleClass('hover')
    $(this)
      .siblings()
      .removeClass('hover')
  }
})

$(document).on('click', '[data-filters-action]', function() {
  if ($(this).data('filters-action') == 'open') {
    $('.sj-filters').addClass('-open')
  } else if ($(this).data('filters-action') == 'close') {
    $('.sj-filters').removeClass('-open')
  }
})

var cmsDomain = 'https://cms.stjohnrestaurant.com'
var imgixDomain = 'https://st-john-srvsrv-co.imgix.net'

var collectionHeroImages = function() {
  if ($('.sj-collection-hero').length == 0) {
    return
  }

  $('.sj-collection-hero').each(function() {
    var imgEl, src
    imgEl = $(this).find('img')[0]
    if (imgEl.currentSrc) {
      src = imgEl.currentSrc
    } else {
      src = imgEl.src
    }
    $(this).css('background-image', 'url(' + src + ')')
  })
}

var renderSelectorWrapper = function(el) {
  var $selectorWrapper, $checkedOption
  $selectorWrapper = $(el)
  $checkedOption = $selectorWrapper.find('option:checked')
  if ($checkedOption.length == 0) {
    $checkedOption = $selectorWrapper.find('option:first')
    $checkedOption.prop('checked', true)
  }
  $selectorWrapper
    .find('label')
    .attr('data-val', $checkedOption.text())
    .hide()
    .show()
}

var openOverlay = function(content) {
  var $content
  $content = $(content).clone()
  $('.sj-overlay__content').html($content)
  $('.sj-overlay__content').append(
    '<span class="sj-overlay__close">Close</span>'
  )
  $('.sj-overlay').addClass('-visible')
}

var closeOverlay = function() {
  $('.sj-overlay__content').empty()
  $('.sj-overlay').removeClass('-visible')
}

var opentable = function() {
  var opentableId
  opentableId = $('[data-opentable-selector]').val()
  $('[data-opentable-id]').hide()
  $('[data-opentable-id="' + opentableId + '"]').show()
}

var showReservations = function() {
  if (window.matchMedia('(max-width: 699px)').matches) {
    window.location = '/pages/reservations'
    return
  }

  if ($('.sj-reservations').is(':visible')) {
    return
  }

  var el
  hideNavigation()
  el = $('.sj-reservations')[0]
  $('.sj-reservations').show()
  // $('.sj-reservations').find('.selector-wrapper').hide();
  // setTimeout(function () {
  //   $('.sj-reservations').find('.selector-wrapper').show();;
  // }, 20);
  tl = new TimelineLite()
  tl.set(el, { x: '100%' })
  tl.to(el, 0.2, { x: '0%', ease: Power1.easeOut })
}

var hideReservations = function() {
  var $el, el
  $el = $('.sj-reservations')
  el = $el[0]
  tl = new TimelineLite()
  tl.to(el, 0.2, { x: '100%', ease: Power1.easeIn })
  tl.call(function() {
    $el.hide()
  })
}

var positionNav = function() {
  var headerHeight
  headerHeight = $('.sj-page-header').outerHeight()
  $('.sj-navigation').css({
    maxHeight: 'calc(100vh - ' + headerHeight + 'px)',
    top: headerHeight
  })
}

$(document).on('click', '.sj-divided-columns__column.-expandable', function() {
  $(this).toggleClass('-is-expanded')
})

$(document).on('click', '[data-open="reservations"]', showReservations)
$(document).on('click', '.sj-reservations__close', hideReservations)

$(document).on('change', '[data-opentable-selector]', opentable)

$(document).on('click', function(e) {
  if ($('[data-reservations]').is(e.target)) {
    return
  }
  $reservations = $('.sj-reservations')
  $reservationsMastheadLink = $('[data-open="reservations"]')
  if (
    $reservations.has(e.target).length == 0 &&
    !$reservations.is(e.target) &&
    !$reservationsMastheadLink.is(e.target)
  ) {
    hideReservations()
  }
})

$(document).on('click', function(e) {
  $menus = $('.sj-menus')
  if ($menus.has(e.target).length == 0 && !$menus.is(e.target)) {
    $menus.removeClass('-active')
  }
})

$(document).on('click', function(e) {
  $overlayContent = $('.sj-overlay__content')
  if ($(e.target).hasClass('sj-section-imagetext__open')) {
    return
  }
  if (
    $overlayContent.has(e.target).length == 0 &&
    !$overlayContent.is(e.target)
  ) {
    closeOverlay()
  }
})

$(document).on('click', '[data-reservations]', function() {
  var opentableId
  opentableId = $(this).data('reservations')
  $('[data-opentable-selector]')
    .val(opentableId)
    .trigger('change')
  showReservations()
})

var hideNavigation = function() {
  var $el, el, $toggle
  $el = $('.sj-navigation')

  if (!$el.hasClass('-active')) {
    return
  }

  el = $el[0]
  tl = new TimelineLite()
  tl.to(el, 0.2, { y: '-100%', ease: Power1.easeIn })
  tl.call(function() {
    $el.removeClass('-active').hide()
  })
  $toggle = $('[data-toggle="navigation"]')
  $toggle.html($toggle.data('inactive'))
}

var showNavigation = function() {
  var $el, el, $toggle
  $el = $('.sj-navigation')
  $el.show()
  el = $('.sj-navigation')[0]
  tl = new TimelineLite()
  tl.set(el, { y: '-100%' })
  tl.to(el, 0.2, { y: '0%', ease: Power1.easeOut })
  tl.call(function() {
    $el.addClass('-active')
  })
  $toggle = $('[data-toggle="navigation"]')
  $toggle.html($toggle.data('active'))
}


$(document).on('click', '.sj-menus', function() {
  var $this
  $this = $(this)
  $this.toggleClass('-active')
})

$(document).on('click', '.sj-section-imagetext__open', function() {
  openOverlay(
    $(this)
      .parents('.sj-section-imagetext')
      .find('.-more')
  )
})

$(document).on('click', '.sj-overlay__close', function() {
  closeOverlay()
})

$(document).on('click', '.shopify-quantity__dec', function() {
  var $this, $input, currentVal
  $this = $(this)
  $input = $this.siblings('.shopify-quantity__input')
  currentVal = parseInt($input.val())
  if (currentVal == 1) {
    return
  }
  $input.val(currentVal - 1)
})

$(document).on('click', '.shopify-quantity__inc', function() {
  var $this, $input, currentVal, maxValue
  $this = $(this)
  $input = $this.siblings('.shopify-quantity__input')
  maxValue = $input.data('max-value') || 99
  currentVal = parseInt($input.val())
  if (currentVal < maxValue) $input.val(currentVal + 1)
})

var showAppropriateCartFooter = function() {
  var shippingMethod

  shippingMethod = $('[name="shipping"]:checked').val()

  if (shippingMethod == 'deliver') {
    $('.sj-cart-footer__click-and-collect').addClass('-hidden')
    $('.sj-cart-footer__deliver').removeClass('-hidden')

    newCartUrl = '/cart?step=contact_information'
    newCartUrl += [
      '&checkout[shipping_address][company]=',
      '&checkout[shipping_address][address1]=',
      '&checkout[shipping_address][city]=',
      '&checkout[shipping_address][zip]=',
      '&checkout[shipping_address][country]=',
      '&checkout[shipping_address][province]='
    ].join('')

    $('.sj-cart-form').attr('action', newCartUrl)
    // $('.sj-cart-form').attr('action', '/cart');
  } else if (shippingMethod == 'click-and-collect') {
    $('.sj-cart-footer__deliver').addClass('-hidden')
    $('.sj-cart-footer__click-and-collect').removeClass('-hidden')
    $('[name="click-and-collect"]').trigger('change')
  }
}

$(document).on('cart.ready', function(event, cart) {
  showAppropriateCartFooter()
})

$(document).on('change', '[name="shipping"]', showAppropriateCartFooter)

$(document).on('change', '[name="click-and-collect"]', function() {
  var $form, location, newCartUrl

  $form = $('.sj-cart-form')
  location = $('[name="click-and-collect"]:checked').val()
  newCartUrl = '/cart?step=contact_information'

  if (location == 'smithfield') {
    newCartUrl += [
      '&checkout[shipping_address][company]=' +
        encodeURIComponent('St. JOHN Smithfield (Click & Collect)'),
      '&checkout[shipping_address][address1]=' +
        encodeURIComponent('26 St John Street'),
      '&checkout[shipping_address][city]=' + encodeURIComponent('London'),
      '&checkout[shipping_address][zip]=' + encodeURIComponent('EC1M 4AY'),
      '&checkout[shipping_address][country]=United Kingdom',
      '&checkout[shipping_address][province]=null'
    ].join('')
  } else if (location == 'bread-and-wine') {
    newCartUrl += [
      '&checkout[shipping_address][company]=' +
        encodeURIComponent('St. JOHN Bread & Wine (Click & Collect)'),
      '&checkout[shipping_address][address1]=' +
        encodeURIComponent('94-96 Commercial Street'),
      '&checkout[shipping_address][city]=' + encodeURIComponent('London'),
      '&checkout[shipping_address][zip]=' + encodeURIComponent('E1 6LZ'),
      '&checkout[shipping_address][country]=United Kingdom',
      '&checkout[shipping_address][province]=null'
    ].join('')
  } else if (location == 'neals-yard') {
    newCartUrl += [
      '&checkout[shipping_address][company]=' +
        encodeURIComponent('Neal’s Yard (Click & Collect)'),
      '&checkout[shipping_address][address1]=' +
        encodeURIComponent('3 Neal’s Yard, Seven Dials'),
      '&checkout[shipping_address][city]=' + encodeURIComponent('London'),
      '&checkout[shipping_address][zip]=' + encodeURIComponent('WC2H 9DP'),
      '&checkout[shipping_address][country]=United Kingdom',
      '&checkout[shipping_address][province]=null'
    ].join('')
  } else if (location == 'maltby') {
    newCartUrl += [
      '&checkout[shipping_address][company]=' +
        encodeURIComponent('St. JOHN Maltby (Click & Collect)'),
      '&checkout[shipping_address][address1]=' +
        encodeURIComponent('Ropewalk, 41 Maltby Street'),
      '&checkout[shipping_address][city]=' + encodeURIComponent('London'),
      '&checkout[shipping_address][zip]=' + encodeURIComponent('SE1 3PA'),
      '&checkout[shipping_address][country]=United Kingdom',
      '&checkout[shipping_address][province]=null'
    ].join('')
  } else if (location == 'bakery') {
    newCartUrl += [
      '&checkout[shipping_address][company]=' +
        encodeURIComponent('St. JOHN Bakery (Click & Collect)'),
      '&checkout[shipping_address][address1]=' +
        encodeURIComponent('72 Druid Street'),
      '&checkout[shipping_address][city]=' + encodeURIComponent('London'),
      '&checkout[shipping_address][zip]=' + encodeURIComponent('SE1 2HQ'),
      '&checkout[shipping_address][country]=United Kingdom',
      '&checkout[shipping_address][province]=null'
    ].join('')
  }

  $form.attr('action', newCartUrl)
})

$(function() {
  $('.sj-product-wine__image').wrap(
    '<div class="sj-product-wine__image-wrapper">'
  )
  stj.equalizeWineImageHeights()
  // if (window.location.hash == '#test' && CartJS.cart.item_count > 0) {
  //   $('.sj-cart-shipping').css('display', 'flex');
  // }

  if ($('.sj-related-wine').length) {
    var handle, xhr
    handle = $('.sj-related-wine').data('handle')
    if (typeof handle !== 'undefined') {
      xhr = jQuery.getJSON(
        'https://cms.stjohnrestaurant.com/api/products/related?handle=' + handle
      )
      xhr.done(function(response) {
        // console.log('response', response);
        if (response.length) {
          $('.sj-related-wine[data-handle]').html(
            Mark.up(
              '{{products}}<a class="sj-product-wine" href="/collections/wines/products/{{handle}}" data-handle="{{handle}}"><img class="sj-product-wine__image" src="{{imageUrl}}" alt="{{title}}"><h2 class="sj-h3 sj-product-wine__title">{{title}}</h2><div class="sj-product-wine-meta"><span>{{producer}}</span><span>{{region}}</span><span>{{price}}</span></div></a>{{/products}}',
              response
            )
          )
        } else {
          $('.sj-related-wine[data-handle]').hide()
        }
      })
    }
  }

  objectFitImages()

  collectionHeroImages()

  $('.sj-navigation [data-image]').each(function() {
    var $this
    $this = $(this)
    $('<img>', {
      'ix-src': $this.data('image'),
      'data-href': $this.attr('href'),
      sizes: '50vw'
    }).appendTo('.sj-navigation__image')
  })
  imgix.init()

  opentable()

  positionNav()

  $('textarea.expanding').expanding()

  $('[data-cms-src]').each(function() {
    var $this
    $this = $(this)
    $this.attr('src', cmsDomain + $this.data('cms-src'))
  })

  $('[data-imgix-src]').each(function() {
    var $this
    $this = $(this)
    $this.attr('src', imgixDomain + '/' + $this.data('imgix-src'))
  })

  $('[data-cms-background-image]').each(function() {
    var $this
    $this = $(this)
    $this.css(
      'background-image',
      'url(' + cmsDomain + $this.data('cms-background-image') + ')'
    )
  })

  $('.sticky').Stickyfill()

  $('.selector-wrapper').each(function() {
    renderSelectorWrapper(this)
  })

  $('.selector-wrapper select').on('change', function() {
    renderSelectorWrapper($(this).parents('.selector-wrapper'))
  })

  $('.owl-carousel').each(function() {
    var $this, childrenLength, loop
    $this = $(this)
    childrenLength = $this.children().length
    loop = childrenLength > 1 ? true : false
    nav = true
    if (typeof $this.data('nav') !== 'undefined') {
      nav = $this.data('nav')
    }
    autoplay = false
    if (typeof $this.data('autoplay') !== 'undefined') {
      autoplay = $this.data('autoplay')
    }
    $this.owlCarousel({
      loop: loop,
      items: 1,
      nav: nav,
      autoplay: autoplay,
      autoplayHoverPause: true,
      navText: [
        '<svg width="27" height="20" viewBox="0 0 27 20" xmlns="http://www.w3.org/2000/svg"><path d="M.844 10.69l-.005.005 7.944 8.74.004-.004c.01.01.01.024.02.033.31.31.814.31 1.124 0 .3-.3.305-.78.022-1.09l.005-.006-6.738-7.41h22.04c.44 0 .796-.356.796-.795 0-.44-.357-.793-.796-.793H3.224L9.96 1.952l-.004-.003c.283-.313.28-.79-.022-1.092-.31-.31-.813-.31-1.124 0-.01.01-.013.022-.02.032L8.784.887.84 9.627l.004.003c-.274.302-.274.758 0 1.06" fill="#FFF" fill-rule="evenodd"/></svg>',
        '<svg width="26" height="19" viewBox="0 0 26 19" xmlns="http://www.w3.org/2000/svg"><path d="M25.11 9.005L25.115 9 17.202.296 17.197.3c-.01-.008-.01-.02-.02-.03-.31-.31-.81-.31-1.12 0-.3.3-.303.777-.02 1.087l-.006.004 6.71 7.38H.79c-.436 0-.79.356-.79.793 0 .438.354.79.79.79h21.95l-6.71 7.384.006.003c-.282.31-.28.787.022 1.086.308.31.81.31 1.12 0 .008-.01.01-.022.02-.032l.004.004 7.913-8.703-.005-.004c.272-.3.272-.753 0-1.054" fill="#FFF" fill-rule="evenodd"/></svg>'
      ]
    })
  })

  $('.sj-divided-columns').each(function() {
    var $this
    $this = $(this)
    $this.attr('data-columns', $this.children().length)
  })
})

if ($('.sj-section-article__image').length) {
  $('.sj-section-article__image').height(
    $('.sj-section-article__content').outerHeight()
  )
  $(window).on('optimizedResize', function() {
    $('.sj-section-article__image').height(
      $('.sj-section-article__content').outerHeight()
    )
  })
}

$(document).on('click', '[data-href]', function(e) {
  e.preventDefault()
  if (e.target.tagName == 'A') {
    e.stopImmediatePropagation()
    return
  }
  window.location = $(this).data('href')
})

$(window).on('optimizedResize', positionNav)
$(window).on('optimizedResize', collectionHeroImages)

$(document).on('click', '.sj-restaurant-notice__toggle', function() {
  $(this)
    .parents('.sj-restaurant-notice')
    .toggleClass('-expanded')
})

// $(document).on('keyup', '#q', function(e) {
//   var queryParams;
//
//   queryParams = {
//     q: $(this).val()
//   }
//
//   $.ajax({
//     url: 'https://st-john.srvsrv.co/api/products/search',
//     data: queryParams,
//     headers: { 'X-St-John-Api-Token': 'C1TZr4rDWzJwKA7XHxhbSdzFtrtAozbejwrr' }}
//   ).done(function(response) {
//     console.log(response);
//   });
// });

$(document).on('submit', '.sj-search', function(e) {
  e.preventDefault()
})

// $(document).one('focusin', '#q', function() {
//   $('.uncomplicated-search-overlay').wrapInner('<div class="sj-search-wrapper">');
// });

$(document).on('focusin', '#q', function() {
  $(this)
    .parents('form')
    .addClass('-focussed')
})

$(document).on('focusout', '#q', function() {
  var $this = $(this)
  $this.val('')
  $this.parents('form').removeClass('-focussed')
})

rivets.formatters.append = function(string, append) {
  return string + append
}

rivets.formatters.replace = function(string, find, replace) {
  return string.replace(find, replace)
}

rivets.formatters.propertyArray = function(obj) {
  var output
  output = Object.keys(obj).map(function(key) {
    return { key: key, value: obj[key] }
  })
  return output
}

rivets.formatters.has_wine = function(items) {
  var item
  for (var i = 0; i < items.length; i++) {
    item = items[i]
    if (item.vendor == 'Vintner' || item.vendor == 'Vision') {
      return true
    }
  }
  return false
}

rivets.formatters.has_hamper = function(items) {
  var item
  for (var i = 0; i < items.length; i++) {
    item = items[i]
    if (/hamper/i.test(item.title)) {
      return true
    }
  }
  return false
}

rivets.formatters.note_placeholder = function(items) {
  var item, placeholders, hasWine

  placeholders = []
  hasHamper = rivets.formatters.has_hamper(items)
  hasWine = rivets.formatters.has_wine(items)

  for (var i = 0; i < items.length; i++) {
    item = items[i]
    // if (hasHamper) {
    //   placeholders.push(
    //     'For your hamper delivery: please specify your preferred delivery day between December 3rd and December 22nd'
    //   )
    // }
    if (hasWine) {
      placeholders.push(
        'For your wine delivery: I will be in all day // this is a work address, leave with receptionist  // leave in shed // leave with number 27'
      )
    }
    return placeholders.join(' // ')
  }
  return false
}

rivets.formatters.has_wine_or_hamper = function(items) {
  var item
  for (var i = 0; i < items.length; i++) {
    item = items[i]
    if (item.vendor == 'Vintner' || item.vendor == 'Vision' || /hamper/i.test(item.title)) {
      return true
    }
  }
  return false
}

var bottleCount = function(items) {
  var count
  count = 0
  for (var i = 0; i < items.length; i++) {
    var item
    item = items[i]
    if (item.variant_title && item.variant_title.search('Bottle') >= 0) {
      count += item.quantity
    } else if (item.variant_title && item.variant_title.search('Case') >= 0) {
      count += 12
    }
  }
  return count
}

rivets.formatters.includes = function(t, e) {
  if (t == null) {
    return false
  }
  return t.indexOf(e) >= 0
}

rivets.formatters.is_valid_order = function(items) {
  return true

  var hasWine, isValidOrder, cart

  cart = CartJS.cart
  hasWine = rivets.formatters.has_wine(items)
  isValidOrder = false

  return true
}

$(window).on('load', function() {
  $('[data-cart-view]').show()
  stj.equalizeWineImageHeights()
})

$(document).on('click', '#ageverify-click-and-collect', function() {
  var checked
  checked = $(this).prop('checked')
  $('#ageverify-deliver').prop('checked', checked)
})

$(document).on('click', '#ageverify-deliver', function() {
  var checked
  checked = $(this).prop('checked')
  $('#ageverify-click-and-collect').prop('checked', checked)
})

$(document).on('click', '.sj-cart-buttons__left button', function(e) {
  var cartItems = cart.items
  var wineItemsCount = cartItems.filter(function(i) {
    return i.vendor === 'Vintner' || i.vendor === 'Vision'
  }).length
  var merchItemsCount = cartItems.filter(function(i) {
    return i.vendor !== 'Vintner' && i.vendor !== 'Vision'
  }).length

  if (
    $('.sj-cart-footer__left').is(':visible') &&
    $('[name="shipping"]:checked').val() == 'deliver'
  ) {
    if ($('#CartSpecialInstructions').val() == '') {
      e.preventDefault()
      alert(
        'You must provide Specific Delivery Instructions before you can checkout.'
      )
      return
    }
  }

  shippingMethod = $('[name="shipping"]:checked').val()

  if ($('.sj-cart-ageverify').is(':visible')) {
    if (!$('#ageverify-' + shippingMethod).prop('checked')) {
      e.preventDefault()
      alert(
        'You must confirm that you over 18 years old before you can checkout.'
      )
      return
    }
  }
})

$(document).on('click', '.menu-icon', function(e) {
  $('#nav-menu').toggle();
});
